import { render, staticRenderFns } from "./stock-manage.vue?vue&type=template&id=32e31bf7&scoped=true&"
import script from "./stock-manage.vue?vue&type=script&lang=js&"
export * from "./stock-manage.vue?vue&type=script&lang=js&"
import style0 from "./stock-manage.vue?vue&type=style&index=0&id=32e31bf7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e31bf7",
  null
  
)

export default component.exports